<template>
  <div class="modal fade" id="absence-modal" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span>Utlys vikariat för <span id="absence-modal-date"></span></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal">
            <span><b>x</b></span>
          </button>
        </div>
        <div class="modal-body pb-5">
          <div class="row">
            <div class="col-md-12">
              <h5 class="text-danger">Observera att du nu utlyser ett vikariat för hela dagen där alla schemalagda tider
                ingår.</h5>
              <span class="hidden" id="absence-modal-batch-hidden"></span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="addAbsences"><i class="fa fa-check"></i> {{ transEdit('accept') }}
          </button>
          <button class="btn btn-dark" data-dismiss="modal"><i class="fa fa-ban"></i> {{ transEdit('cancel') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  name: "AdminSchedulesModalAbsence",
  props: ['schedules'],
  data() {
    return {
    }
  },
  methods: {
    addAbsences() {
      let batchId = $("#absence-modal-batch-hidden").text();
      let scheduleDate = $("#absence-modal-date").text();
      let thisModal = $("#absence-modal");
      axios.post('adminschedule/batch/createAbsence', {
        'batch_id': batchId,
        'date': scheduleDate,
      }).then((res) => {
        if (!res.error) {
          Vue.toasted.success(res.data.data);
        } else {
          Vue.toasted.error(res.data[1]);
        }
        this.$emit('refresh');
        thisModal.modal('toggle');
      });
    },
  }
}
</script>

<style scoped>

</style>
